import { SpendConfirmationActionType } from './useSpendConfirmationAction';
import { useTranslation } from 'react-i18next';

export function useSpendConfirmationMessage(
  actionType: SpendConfirmationActionType
) {
  const { t } = useTranslation();

  switch (actionType) {
    case SpendConfirmationActionType.RemoveBackground:
      return t('dreamup.modal.spendConfirmation.message.removeBackground');
    case SpendConfirmationActionType.Upscale:
    default:
      return t('dreamup.modal.spendConfirmation.message.upscale');
  }
}
